import type { ExplorerConditionGroup } from "./explorerConditions.constants"
import type { ExplorerTypeId } from "./explorerViews.constants"

/**
 * Which picker group each grid column sits under, per record type, in the
 * order the Columns panel lists them. The groups are the Add condition
 * menu's, so both pickers read alike. A type left out shows one flat list.
 */
export const EXPLORER_COLUMN_GROUPS: Partial<
    Record<
        ExplorerTypeId,
        Partial<Record<ExplorerConditionGroup, readonly string[]>>
    >
> = {
    shipments: {
        load: [
            "reference",
            "status",
            "carrier",
            "serviceType",
            "equipment",
            "totalWeight",
            "quotedCost",
            "distance",
            "transitTime",
            "lastUpdate",
        ],
        places: [
            "shipper",
            "shipperEmail",
            "shipperPhone",
            "consignee",
            "consigneeEmail",
            "consigneePhone",
            "assignee",
            "origin",
            "destination",
        ],
        dates: ["pickupDate", "deliveryDate", "createdAt"],
        paperwork: ["bol", "pod", "invoice"],
    },
    salesOrders: {
        load: [
            "reference",
            "status",
            "fulfillmentStatus",
            "totalAmount",
            "lastUpdate",
        ],
        places: ["customerName", "origin", "destination"],
        dates: ["orderDate", "requestedDeliveryDate", "createdAt"],
    },
    quotes: {
        load: [
            "reference",
            "status",
            "rate",
            "serviceType",
            "transitDays",
            "distance",
            "lastUpdate",
        ],
        places: ["vendorName", "origin", "destination"],
        dates: ["createdAt"],
    },
    vendors: {
        load: [
            "name",
            "vendorType",
            "status",
            "dotNumber",
            "mcNumber",
            "serviceTypes",
            "lastUpdate",
        ],
        places: ["contactName", "contactEmail", "contactPhone"],
        dates: ["createdAt"],
    },
    addressBook: {
        load: ["name", "locationType", "businessHours", "lastUpdate"],
        places: [
            "city",
            "state",
            "postalCode",
            "contactName",
            "contactEmail",
            "phoneNumber",
        ],
        dates: ["createdAt"],
    },
    contacts: {
        load: ["name", "company", "role", "updatedAt"],
        places: ["primaryEmail", "primaryPhone"],
        dates: ["createdAt"],
    },
    products: {
        load: [
            "name",
            "sku",
            "status",
            "description",
            "dimensions",
            "weight",
            "freightClass",
            "quantity",
            "lastUpdate",
        ],
        dates: ["createdAt"],
    },
}
